import { useTranslation } from "next-i18next"

const useGeneric = ({ componentProps: { headLine } = {} }) => {
  const { t } = useTranslation()
  const i18n = {
    myAccount: t("kf.account.label.myAccount"),
    myServices: t("kf.account.label.myServices"),
    favoriteTitle: t("kf.favorite.label.favoriteTitle"),
    orders: t("kf.account.label.orders"),
    myProducts: headLine ?? t("kf.myProducts.label.myProducts"),
    hi: t("kf.account.label.hi"),
    accountSettings: t("kf.account.label.accountSettings"),
  }

  return i18n
}

export default useGeneric
